import { Button, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@material-ui/core";
import { formatLabel, generateConcatenatedFile } from "./Utils/Helpers";
import { GetApp, Replay } from "@material-ui/icons";

export default function AutoProcessPreview(props) {
  let recordCount = 0;
  const fileOutputHistory = props.sessionHistory?.filter(r => r.content.role === 'model' && r.content.isFileOutputPart);
  const headers = [];
  const fileOutputComponents = [];
  
  fileOutputHistory?.forEach((m, mIndex) => {
    const records = JSON.parse(m.content.data);
    recordCount += records.length - 1;

    if (fileOutputComponents?.length > 151) return;

    if (mIndex === 0 && !headers?.length) headers.push(...Object.keys(records[0]));

    records?.forEach((r, rIndex) => {
      if (fileOutputComponents?.length > 151) return;
      if (rIndex === records.length - 1 && Object.keys(r)?.length < headers.length) return;

      fileOutputComponents.push(
        <TableRow key={m.messageId + '-' + mIndex + '-' + rIndex}>
          {headers.map((col, c) => (
            <TableCell key={c} style={{borderRight: "1px solid #FFFFFF", borderLeft: "1px solid #FFFFFF"}}>
              {r[col]}
            </TableCell>
          ))}
        </TableRow>
      );
    });
  });

  return (
    <>
      <Grid item xs={12} md={12} lg={12}>
        <Typography variant="h4">
          Step 3: Results Preview
        </Typography>
        <Typography>
          The table below is a preview that contains a subset of records from the final output of the conversion. Please verify that the output is correct. If everything looks good, click on the download button. If there are any issues, please click the retry button. 
        </Typography>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        { fileOutputComponents.length ? (
            <>
              <TableContainer key={props.id} style={{overflow: "scroll", maxHeight: "600px"}}>
                <Table stickyHeader size="small">
                  <TableHead>
                    <TableRow>
                      {headers?.map((h, index) => {
                        return (
                          <TableCell 
                            id="header" 
                            key={h} 
                            style={{
                              textDecoration: "none", 
                              borderRadius: "0px", 
                              borderRight: "1px solid #FFFFFF", 
                              borderLeft: "1px solid #FFFFFF", 
                              backgroundColor: "#142e3e", 
                              color: "#28c4fc"
                              }}
                            >
                            <b>{formatLabel(h)}</b>
                          </TableCell>
                        )
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {fileOutputComponents}
                  </TableBody>
                </Table>
              </TableContainer>
              <Grid container alignContent='center' style={{backgroundColor: "#6f6f6f", color: "#FFFFFF", padding: "10px", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px", textAlign: 'left'}}>
                <Grid item xs={12}>
                  {(fileOutputComponents.length - 1) + ' / ~' + recordCount + ' records (Duplicates will be removed when downloaded)'}
                </Grid>
              </Grid>
            </>
          ) : undefined
        }
      </Grid>
      <Grid item xs={12} md={12} lg={12} style={{textAlign: "right"}}>
        <Button 
          variant="contained"
          onClick={() => props.reloadStep()}
          style={{backgroundColor: "#FFFFFF"}}
          startIcon={<Replay />}
        >
          Retry Auto Processing
        </Button>
        <Button 
          variant="contained"
          onClick={() => generateConcatenatedFile(fileOutputHistory, props.sessionHistory?.find(m => m.content.filename)?.content?.filename?.replace(/\..*$/, ''))}
          style={{backgroundColor: "#4caf50", color: "#FFFFFF", marginLeft: "20px"}}
          startIcon={<GetApp />}
        >
          Download File
        </Button>
        <Button 
          variant="contained"
          onClick={() => props.finishConversion()}
          style={{backgroundColor: "#142e3e", color: "#28c4fc", marginLeft: "20px"}}
        >
          Start New Session
        </Button>
      </Grid>
    </>
  )
}